import { Form, Row } from 'antd';
import classNames from 'classnames/bind';
import styles from './FormDouble.module.scss';

const cx = classNames.bind(styles);

const DoubleModal = ({ onAgreeDouble, onRejectDouble, text }) => {
    return (
        <Form>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Confirm
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')}>
                    {text}
                </Row>
            </Form.Item>
            {/* <Form.Item>
                <Row justify="center">
                    <img src={SVGS.IconNotiCancel} alt="" />
                </Row>
            </Form.Item> */}
            <Form.Item style={{ marginTop: '40px' }}>
                <Row>
                    <div className={cx('btn_cancel')} onClick={onRejectDouble}>
                        Cancel
                    </div>
                    <div className={cx('btn_logout')} onClick={onAgreeDouble}>
                        Agree
                    </div>
                </Row>
            </Form.Item>
        </Form>
    );
};

export default DoubleModal;
